(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["claro-hero"] && !Shopify.designMode) return;
  try {
    
  function initializeClaroHero(section) {
    if (!(section instanceof HTMLElement)) return;
    if (section.dataset.hotspotBound === 'true') return;

    const trigger = section.querySelector('[data-claro-hero-hotspot-trigger]');
    const card = section.querySelector('[data-claro-hero-hotspot-card]');
    const closeButton = section.querySelector('[data-claro-hero-hotspot-close]');

    if (!(trigger instanceof HTMLButtonElement)) return;
    if (!(card instanceof HTMLElement)) return;

    section.dataset.hotspotBound = 'true';

    const closeCard = (restoreFocus = false) => {
      card.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');

      if (restoreFocus) {
        trigger.focus({ preventScroll: true });
      }
    };

    trigger.addEventListener('click', () => {
      const shouldOpen = card.hidden;

      card.hidden = !shouldOpen;
      trigger.setAttribute('aria-expanded', String(shouldOpen));
    });

    closeButton?.addEventListener('click', () => {
      closeCard(true);
    });

    section.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || card.hidden) return;
      event.preventDefault();
      closeCard(true);
    });
  }

  function initializeClaroHeroes(root = document) {
    if (root instanceof HTMLElement && root.matches('[data-claro-hero-section]')) {
      initializeClaroHero(root);
      return;
    }

    root
      .querySelectorAll('[data-claro-hero-section]')
      .forEach(initializeClaroHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initializeClaroHeroes();
    }, { once: true });
  } else {
    initializeClaroHeroes();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (!(event.target instanceof HTMLElement)) return;

    if (event.target.matches('[data-claro-hero-section]')) {
      initializeClaroHero(event.target);
      return;
    }

    const section = event.target.querySelector('[data-claro-hero-section]');
    if (section) initializeClaroHero(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
